import flattenMessages from '../../helpers/flattenMessages';
import en from './en.json';
import ja from './ja.json';

export default {
  en: flattenMessages(en, 'about-us'),
  ja: flattenMessages(ja, 'about-us'),
};
